<template>
    <div>
          <div  class="row drag-el drop-zone"
                v-for="(route, index) in this.store.state.orderTrueDriver.customRoutes" :key="route.id"
                :data-id="index"
                draggable="true"
                @dragstart="startDrag($event, store.state.orderTrueDriver.customRoutes.indexOf(route))"
                @dragenter="dragEnter($event)"
                @dragleave="dragLeave($event)"
                @dragover="dragOver($event)"
                @drop="onDrop($event)"
                @dragend="dragEnd()">
            <div class="col-12">
              <div class="row">
                
                  <template v-if="index === 0">
                    <div class="col-12">
                        <div class="row">
                            <div class="col-1 m-0"></div>
                            <div class="col-11 m-0" style="padding-left: 17px; font-weight: 600;">
                                {{ $t('drive_from')}}
                            </div>
                        </div>
                    </div>
                  </template>

                  <template v-if="index === this.store.state.orderTrueDriver.customRoutes.length - 1 && this.store.state.orderTrueDriver.customRoutes.length > 1">
                    <div class="col-12">
                        <div class="row">
                            <div class="col-1 m-0"></div>
                            <div class="col-11 m-0" style="padding-left: 17px; font-weight: 600;">
                                {{ $t('drive_to')}}
                            </div>
                        </div>
                    </div>
                  </template>
                

                <div class="col-12" >
                  <div class="row align-items-center">

                    <template v-if="index === 0">
                      <div class="col-1 pe-0 text-right" style="margin-bottom: 0.625rem;">
                        <img src="/assets/images/frame-arrow.svg" alt="arrow">
                      </div>
                    </template>

                    <template v-else-if="index === this.store.state.orderTrueDriver.customRoutes.length - 1">
                      <div class="col-1 pe-0 text-right" style="margin-bottom: 0.625rem;">
                        <img src="/assets/images/frame-flag.svg" alt="flag">
                      </div>
                    </template>

                    <template v-else>
                      <div class="col-1" style="height: 74px;">
                        <div class="dots-img"></div>
                      </div>
                    </template>
 
                    <div class="col-11 m-0">
                      <CustomRouteAddressSelectComponent

                          :place-holder="index === 0 ? $t('enter_pickup_address') : $t('enter_destination_address')"
                          :id="route.id"
                          :location-store="route.routePoint"
                          :arrival-time="route.arrivalTime"
                          :isRemovable="isRouteRemovable(index)"
                          :index="firstIndex(index)"
                          
                          @getAddresses="getAddresses"
                          @deleteRoute="deleteRoute"
                          @getArrivalTime="getCustomArrivalTime"
                      ></CustomRouteAddressSelectComponent>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

      <div class="row" v-if="this.counter < maxPoints">
        <div class="col-12">
          <div class="add-route-main-container" @click="addRouteInput(maxPoints)">
            <div class="row align-items-center">
              <div class="col-1 pe-0" style="padding-left: 7px;">
                <div class="add-route"></div>
              </div>
              <div class="col-11" style="margin-top: -7px;">
                <div class="add-route-label">{{ $t('add_one_more') }}</div>
              </div>
            </div>
          </div>
        </div>
      </div>

          <div class="d-flex flex-column m-0">
            <span class="custom-route-error-color font-small" v-if="!messagesValidCustomRouteForm.validRoutes.state">
              {{ $t(messagesValidCustomRouteForm.validRoutes.message) }}
            </span>
            <span class="custom-route-error-color font-small" v-if="message.state">
              {{ $t(message.msg) }}
            </span>
          </div>

          <div class="row">
            <div class="col-1 m-0"></div>
            <div class="col-11 input-col-10-padding">
              <div class="hr-line" style="margin-top: 28px; margin-bottom: 24px;"></div>
            </div>
          </div>

        <div class="row">
        <span class="custom-route-error-color font-small" v-if="!messagesValidCustomRouteForm.validSelectedVehicle.state">
          {{ $t(CustomRouteFormTemplateComponentErrorMessages.MESSAGE_SELECTED_VEHICLE) }}
        </span>
            <div class="col-1 m-0"></div>
            <div
                    class="col-11 m-0 position-relative input-col-10-padding"
                    :data-bs-toggle="'modal'"
                    :data-bs-target="'#selectVehicleModal'"
            >
                <input
                        class="vehicle-picker-input"
                        id=""
                        :placeholder="$t('please_select_vehicle')"
                        :value="selectedVehicleValue"
                />
            </div>
        </div>

          <div class="d-flex flex-column m-0">
            <span class="custom-route-error-color font-small" v-if="!messagesValidCustomRouteForm.validTravelObjective.state">
              {{ $t(messagesValidCustomRouteForm.validTravelObjective.message) }}
            </span>
          </div>
          <OptionSelectComponent
              :placeholder="$t('select_travel_objective')"
              :data="this.store.state.orderTrueDriverTravelObjectives.travelObjectives"
              v-model:selected="selectedTravelObjective">
          </OptionSelectComponent>


          <CalendarComponent :is-valid="messagesValidCustomRouteForm.validSelectedPredefinedOption"></CalendarComponent>

  <!--        <div class="d-flex flex-column m-0">-->
  <!--          <span class="custom-route-error-color font-small" v-if="!messagesValidCustomRouteForm.validDuration.state">-->
  <!--            {{ $t(messagesValidCustomRouteForm.validDuration.message) }}-->
  <!--          </span>-->
  <!--          <span class="custom-route-error-color font-small" v-if="!messagesValidCustomRouteForm.validDistance.state">-->
  <!--            {{ $t(messagesValidCustomRouteForm.validDistance.message) }}-->
  <!--          </span>-->
  <!--        </div>-->
          <div class="row">
            <div class="col-1 m-0"></div>
            <div class="col-11 input-col-10-padding">
              <CustomRoutePriceWrapperComponent
                  :total-distance="totalDistance"
                  :total-duration="totalDuration"
                  :price="price"
              ></CustomRoutePriceWrapperComponent>
            </div>
          </div>


          <div class="d-flex flex-column m-0">
            <span class="custom-route-error-color font-small" v-if="!store.state.orderTrueDriver.isValidCustomRouteForm">
              {{ $t(CustomRouteFormTemplateComponentErrorMessages.MESSAGE_CUSTOM_ROUTE_FORM) }}
            </span>

            <!-- BACKEND VALIDATION ERRORS-->
            <template v-for="error in backendValidationErrors">
              <div class="font-small error-color custom-route-error-color">
                {{ $t(error) }}
              </div>
            </template>
          </div>
          <div class="row">
            <div class="col-1 m-0"></div>
            <div class="col-11 input-col-10-padding">
              <template v-if="loading">
                <ButtonComponent class="order-form-submit-button m-0 w-100 mt-3">
                  <template #btnContent>
                    <span class="loader"></span>
                  </template>
                </ButtonComponent>
              </template>
              <template v-else>
                <ButtonComponent
                    class="m-0 w-100 mt-3"

                    :disabled="disabledButton"
                    :class="{'disabled-button' : disabledButton, 'order-form-submit-button' : !disabledButton}"

                    @click="onSubmit($event)">
                  <template #btnContent>
                    {{ !isOrderable ? $t('calculate') : $t('order_now') }}
                  </template>
                </ButtonComponent>
              </template>
            </div>
          </div>
    </div>
</template>

<script lang="ts">
import {defineComponent} from 'vue';
import {useStore} from "vuex";
import type {PropType} from "vue";
import './customRouteFormTemplate.scss';

// @ts-ignore
import AddressSelectComponent from "../AddressSelect/AddressSelectComponent.vue";
// @ts-ignore
import CustomRouteAddressSelectComponent from "../customRouteAddressSelect/CustomRouteAddressSelectComponent.vue";
// @ts-ignore
import CustomRouteFrequencySelectComponent from "../customRouteFrequencySelect/CustomRouteFrequencySelectComponent.vue";
// @ts-ignore
import OptionSelectComponent from "../optionSelect/OptionSelectComponent.vue";
// @ts-ignore
import CustomRoutePriceWrapperComponent from "../customRoutePriceWrapper/CustomRoutePriceWrapperComponent.vue";
// @ts-ignore
import ButtonComponent from '../Button/ButtonComponent.vue';
// @ts-ignore
import CalendarComponent from "../calendar/CalendarComponent.vue";
// @ts-ignore
import apiGoogleService from "../../services/apiGoogleService";
// @ts-ignore
import {routesConst} from "../../routes";
// @ts-ignore
import {CustomRouteFormTemplateComponentErrorMessages} from '../../interfaces/enums/CustomRouteFormTemplateComponentErrorMessages.enum';
// @ts-ignore
import MessageComponent from "../message/MessageComponent.vue";
// @ts-ignore
import FormValidationService from '../../services/formValidationService';
import type {ICustomRoute} from "@/store/states/ICustomRouteState.interface";
import NameOfHelper from "../../helpers/nameOfHelper";
import type {IOrderTrueDriverState} from "@/store/states/IOrderTrueDriverState.interface";
import type {ILocationStore} from "@/store/states/ILocationStoreState.interface";

export default defineComponent({
  name: 'CustomRouteFormTemplateComponent',
  components: {
    CalendarComponent,
    ButtonComponent,
    CustomRoutePriceWrapperComponent,
    OptionSelectComponent,
    CustomRouteFrequencySelectComponent,
    CustomRouteAddressSelectComponent,
    AddressSelectComponent,
    MessageComponent
  },
  emits: ['submit'],
  props: {
    isOrderable: {
      type: Boolean,
      default: false
    },
    totalDistance: {
      type: Number
    },
    totalDuration: {
      type: Object
    },
    price: {
      type: Number
    },
    message: {} as PropType<{ state: boolean, msg: string }>,
    loading: {
      type: Boolean,
      required: true
    },
    backendValidationErrors: {
      default: []
    }
  },
  data() {
    return {
      CustomRouteFormTemplateComponentErrorMessages: CustomRouteFormTemplateComponentErrorMessages,
      elements: [],
      maxPoints: apiGoogleService.MAX_CUSTOM_ROUTE_POINTS,
      counter: 0,
      disabledButton: true,
      selectedTravelObjective: null as string | null | number,

      messagesValidCustomRouteForm: {
        validRoutes: {
          id: 1,
          state: true,
          message: <string | null>null
        },
        validTravelObjective: {
          id: 2,
          state: true,
          message: <string | null>null
        },
        validSelectedPredefinedOption: {
          id: 3,
          state: true,
          message: <string | null>null
        },
        validSelectedVehicle: {
          id: 4,
          state: true,
          message: <string | null>null
        }
        // validDistance: {
        //   id: 4,
        //   state: true,
        //   message: <string | null>null
        // },
        // validDuration: {
        //   id: 5,
        //   state: true,
        //   message: <string | null>null
        // },
      },
    }
  },

  setup() {
    const store = useStore();

    return {
      store
    }
  },

  computed: {
    selectedVehicleValue() {

      if (!this.store.state.vehicle.selectedVehicle) {
        return;
      }
      return `${this.store.state.vehicle.selectedVehicle.make} ${this.store.state.vehicle.selectedVehicle.model} (${this.store.state.vehicle.selectedVehicle.price} ${this.$t('eur_h')})`;
    }
  },

  watch: {
    selectedTravelObjective: {
      handler(newVal, oldVal) {
        this.store.dispatch('orderTrueDriver/updateState', [{prop: 'selectedTravelObjective', value: parseInt(newVal)}]);
      }
    }
  },

  methods: {

    getCustomArrivalTime(payload: {value: string}): void {

      // CUSTOM ROUTE DESTINATION TIME UPDATE
      const routes = [...this.store.state.orderTrueDriver.customRoutes];
      routes[0].arrivalTime = payload.value;

      this.store.dispatch('orderTrueDriver/updateState', [
        {prop: 'customRoutes', value: routes},
        {prop: 'arrivalTime', value: payload.value}
      ]);
    },

    checkDisabledButton(): void {
      this.disabledButton = this.store.state.orderTrueDriver.customRoutes.filter(el => el.routePoint !== null).length <= 1;
    },

    firstIndex(index: number ): boolean {
      return index === 0;
    },

    lastIndex(index: number ): boolean {
      return index === this.store.state.orderTrueDriver.customRoutes.length - 1;
    },

    isRouteRemovable(index: number): boolean {
      const routes = this.store.state.orderTrueDriver.customRoutes;

      return routes.length > 2 && index > 0 && index < routes.length - 1;
    },

    deleteRoute(payload: number): void {
      const nameOf = (c) => NameOfHelper.obj(c);

      let stateName = nameOf(() => this.store.state.orderTrueDriver);
      let state: IOrderTrueDriverState = this.store.state[stateName];

      let routes = [...state.customRoutes];
      routes = routes.filter(route => route.id !== payload);

      this.store.dispatch('orderTrueDriver/updateState', [
        {prop: nameOf(() => state.customRoutes), value: routes},
        {prop: nameOf(() => state.arrivalTime), value: routes[0].arrivalTime},
        {prop: nameOf(() => state.pickup), value: routes[0].routePoint}
      ]);

      this.counter--;
    },

    getAddresses(payload: {value: ILocationStore, pickup: boolean, id: number}): void {
      const nameOf = (c) => NameOfHelper.obj(c);

      let stateName = nameOf(() => this.store.state.orderTrueDriver);
      let state: IOrderTrueDriverState = this.store.state[stateName];

      const routes = [...state.customRoutes].map((route: ICustomRoute, index) => {

        if (route.id === payload.id) {
          route.routePoint = payload.value ? payload.value : null;

          if (index === 0) {
            this.store.dispatch(stateName + '/updateState', [{prop: nameOf(() => state.pickup), value: payload.value}]);
          }
        }

        return route;
      });

      this.store.dispatch(stateName +'/updateState', [{prop: nameOf(() => state.customRoutes), value: routes}]);

      this.checkDisabledButton();

    },

    addRouteInput(maxPoints: number): void {
      const copyCustomRoutes = [...this.store.state.orderTrueDriver.customRoutes];
      const indexes = copyCustomRoutes.map(el => el.id);
      this.counter = copyCustomRoutes.length;

      if (copyCustomRoutes.length === maxPoints) {
        return;
      }

      this.counter++;
      const maxIndex = Math.max(...indexes);

      let newCustomRoutes = <any[]>[];

      let lastItem = null;
      if (copyCustomRoutes.length >= 2) {
        lastItem = copyCustomRoutes.pop();
      }

      newCustomRoutes = [...copyCustomRoutes];

      newCustomRoutes.push({
        id: maxIndex + 1,
        arrivalTime: null,
        routePoint: null
      });

      if (lastItem) {
        newCustomRoutes.push(lastItem);
      }

      this.store.dispatch('orderTrueDriver/updateState', [{prop: 'customRoutes', value: newCustomRoutes}]);

    },

    // DRAG N DROP methods
    startDrag(evt, itemIndex: number): void {
      evt.dataTransfer.dropEffect = 'move'
      evt.dataTransfer.effectAllowed = 'move'
      evt.dataTransfer.setData('itemIndex', itemIndex);
      // @ts-ignore
      this.elements.forEach(el => el.classList.add('drop-no-events'));
    },

    onDrop(evt): void {
      const nameOf = (c) => NameOfHelper.obj(c);

      let stateName = nameOf(() => this.store.state.orderTrueDriver);
      let state: IOrderTrueDriverState = this.store.state[stateName];

      let routes = [...state.customRoutes];

      let temp = routes[evt.dataTransfer.getData('itemIndex')];
      routes[evt.dataTransfer.getData('itemIndex')] = routes[parseInt(evt.target.dataset.id)];
      routes[parseInt(evt.target.dataset.id)] = temp;

      // UPDATE GLOBAL STATES
      this.store.dispatch(stateName + '/updateState', [
          {prop: nameOf(() => state.customRoutes), value: routes},
          {prop: nameOf(() => state.arrivalTime), value: routes[0].arrivalTime},
          {prop: nameOf(() => state.pickup), value: routes[0].routePoint},

          // Reset to not mislead user with already previously calculated stuff from last submit
          { prop: nameOf(() => state.totalDistance), value: 0 },
          { prop: nameOf(() => state.totalDuration), value: { hours: 0, minutes: 0 }},
          { prop: nameOf(() => state.price), value: 0 }
      ]);

      setTimeout(() => {
        // this.onSubmit(evt);
      });
    },

    dragEnter(evt): void {
        evt.target.classList.add('drop-zone-over');
    },

    dragOver(evt): boolean {
        evt.preventDefault();
        evt.target.classList.add('drop-zone-over');

        return false;
    },

    dragLeave(evt): void {
      evt.target.classList.remove('drop-zone-over');
    },

    dragEnd(): void {
      // @ts-ignore
      this.elements.forEach(el => el.classList.remove('drop-zone-over', 'drop-no-events'));
    },

    onSubmit(): void {
      let isValid = true;

      const dataToValidate = {
        routes: this.store.state.orderTrueDriver.customRoutes,
        travelObjective: this.store.state.orderTrueDriver.selectedTravelObjective,
        selectedPredefinedOption: this.store.state.orderTrueDriverDates.selectedPredefinedOption,
        selectedVehicle: this.store.state.vehicle.selectedVehicle,
        // distance: this.store.state.orderTrueDriver.totalDistance,
        // duration: this.store.state.orderTrueDriver.totalDuration
      }

      isValid = FormValidationService.validateCustomRouteForm(dataToValidate, this.messagesValidCustomRouteForm);

      this.store.dispatch('orderTrueDriver/updateState', [{prop: 'isValidCustomRouteForm', value: isValid}]);

      if (!isValid) {
        return;
      }

      this.$emit('submit', {
        isOrderable: this.isOrderable,
      });
    },

    resetAllErrorMessages(): void {
      // RESET MESSAGES
      for (const key of Object.keys(this.messagesValidCustomRouteForm)) {
        this.messagesValidCustomRouteForm[key].state = true;
        this.messagesValidCustomRouteForm[key].message = null;
      }
      this.store.dispatch('orderTrueDriver/updateState', [{prop: 'isValidCustomRouteForm', value: true}]);
    }
  },


  mounted() {
    // @ts-ignore
    this.elements = document.querySelectorAll('.drop-zone');
    this.checkDisabledButton();

    this.selectedTravelObjective = this.store.state.orderTrueDriver.selectedTravelObjective;

    // Try to submit form if it's after a page refresh or something where we already have 2 or more routes
    // Or travel objective not selected just ignore the auto submit
    if (this.store.state.orderTrueDriver.customRoutes.length < 2
        || ! this.store.state.orderTrueDriver.selectedTravelObjective
    ) {
      return;
    }

    // In order for parent component mounted method to be triggered before
    setTimeout(() => {
      this.onSubmit();

      // on component init reset all error messages
      this.resetAllErrorMessages();
    });
  },

  updated() {
    // @ts-ignore
    this.elements = document.querySelectorAll('.drop-zone');
  }
});
</script>

<style lang="scss">
@import "../../../sass/variables";
  .color-danger {
    color: $red;
    top: -0.2rem;
  }

.vehicle-picker-input {
  background: #ffffff;
  border: 1px solid #cacaca;
  border-radius: 0.5rem;
  padding: 1rem;
  font-weight: 400;
  font-size: 0.875rem;
  line-height: 1.25rem;
  color: #000000;
  margin-bottom: 0.625rem;
  width: 100%;
}
</style>


